import * as yup from 'yup';

function ranking(formatMessage) {
  return yup
    .number()
    .transform((value, originalValue) =>
      originalValue === '' ||
      originalValue === null ||
      originalValue === undefined
        ? null
        : value,
    )
    .nullable()
    .optional()
    .typeError(
      formatMessage({
        id: 'RANKING_FIELD_TYPE_ERROR',
        defaultMessage: 'Ranking must be a valid number',
      }),
    )
    .min(
      1,
      formatMessage({
        id: 'RANKING_FIELD_MIN',
        defaultMessage: 'Ranking must be at least 1',
      }),
    )
    .max(
      5,
      formatMessage({
        id: 'RANKING_FIELD_MAX',
        defaultMessage: 'Ranking must be at most 5',
      }),
    );
}

const validationSchema = formatMessage =>
  yup
    .object({
      ranking: ranking(formatMessage),
    })
    .required();

export default validationSchema;
